export class ColorConstants {

  public static readonly WHITE = 'rgba(255, 255, 255, 1)';
  public static readonly BLACK = 'rgba(0, 0, 0, 1)';
  public static readonly RED_80 = 'rgba(220, 53, 69, 0.8)';
  public static readonly RED_100 = 'rgba(220, 53, 69, 1)';
  public static readonly GREEN_80 = 'rgba(67, 160, 71, 0.8)';
  public static readonly GREEN_100 = 'rgba(67, 160, 71, 1)';
  public static readonly GREY = 'rgb(224, 224, 224)';
  public static readonly METAL = 'rgb(197 207 227)';

  // !!! színek sorrendje ne változzon !!!
  public static readonly ORIGINAL_CHART_COLORS = [
    'rgb(54, 162, 235)',
    'rgb(255, 99, 132)',
    'rgb(255, 159, 64)',
    'rgb(75, 192, 192)',
    'rgb(255, 205, 86)',
    'rgb(153, 102, 255)'
  ];
  public static readonly COLOR_PALETTE = [
    'rgb(239, 154, 154)',
    'rgb(255, 99, 132)',
    'rgb(186, 104, 200)',
    'rgb(153, 102, 255)',
    'rgb(121, 134, 203)',
    'rgb(54, 162, 235)',
    'rgb(129, 212, 250)',
    'rgb(75, 192, 192)',
    'rgb(129, 199, 132)',
    'rgb(174, 213, 129)',
    'rgb(220, 231, 117)',
    'rgb(255, 241, 118)',
    'rgb(255, 205, 86)',
    'rgb(255, 159, 64)',
  ];

  public static getColor(index: number, max: number): string {
    return max > 6 ? ColorConstants.COLOR_PALETTE[index % ColorConstants.COLOR_PALETTE.length] : ColorConstants.ORIGINAL_CHART_COLORS[index % ColorConstants.COLOR_PALETTE.length];
  }
}
